export default __webpack_public_path__ + "locales/sr-Latn-RS/Webhooks.json?hash=5ecff938240a37a27410af3cbf3483e1";